module.exports = "../fonts/HelveticaNeueLTW01-45Light.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-45Light.svg
// module id = 3u5d
// module chunks = 1